export default __webpack_public_path__ + "static/media/contract_of_offer.7352b987.pdf";